module.exports = "/_next/static/images/RobustMarketingAppstore@2x-025867afbcf222f0f7ddcaecb1a42c3d.webp";